jQuery(function ($) {
	const Scripts = {
		varInit() {
			this.body = $('body');
			this.header = $('header');
			this.document = $(document);
		},

		headerScripts() {
			let ctrl = this;

			let menuBtn    = $('.header__mobile-btn');
			let menu       = $('.mobile-menu');
			let searchBtn  = $('.header__search-btn');
			let search     = $('.header-search');
			let bg         = $('.cover-bg');

			// —————————————————————————————————————————————————————
			// 1. Обробники кліків по кнопках
			// —————————————————————————————————————————————————————
			menuBtn.on('click', function(e) {
				e.stopPropagation();
				
				// Якщо пошук був відкритий - спочатку закриваємо його
				if (searchBtn.attr('aria-expanded') === 'true') {
					closeSearch();
				}
				
				// Тепер перемикаємо меню
				toggleMenu();
			});

			searchBtn.on('click', function(e) {
				e.stopPropagation();

				// Якщо меню було відкрито - спочатку закриваємо його
				if (menuBtn.attr('aria-expanded') === 'true') {
					closeMenu();
				}

				// Тепер перемикаємо пошук
				toggleSearch();
			});

			// —————————————————————————————————————————————————————
			// 2. Клік по фону закриває все
			// —————————————————————————————————————————————————————
			bg.on('click', function() {
				closeAll();
			});

			// —————————————————————————————————————————————————————
			// 3. автоматичне закриття мобільного меню при resize
			// (якщо стає >= 1024px і воно відкрите)
			// —————————————————————————————————————————————————————
			$(window).on('resize', function() {
				if ($(window).width() >= 1024 && menuBtn.attr('aria-expanded') === 'true') {
					closeMenu();
				}
			});

			// —————————————————————————————————————————————————————
			// 4. Основна логіка (відкрити/закрити меню, пошук)
			// —————————————————————————————————————————————————————

			// Меню: «перемикач»
			function toggleMenu() {
				const isOpen = menuBtn.attr('aria-expanded') === 'true';
				isOpen ? closeMenu() : openMenu();
			}

			function openMenu() {
				menuBtn.attr('aria-expanded', true);
				menu.attr('aria-hidden', false).css('visibility', 'visible');
				updateOverlay();
			}

			function closeMenu() {
				menuBtn.attr('aria-expanded', false);
				menu.attr('aria-hidden', true);

				// Після завершення CSS-анімації повністю приховуємо блок
				menu.on('transitionend', function() {
					if (menu.attr('aria-hidden') === 'true') {
						menu.css('visibility', 'hidden');
					}
					menu.off('transitionend');
				});

				updateOverlay();
			}

			// Пошук: «перемикач»
			function toggleSearch() {
				const isOpen = searchBtn.attr('aria-expanded') === 'true';
				isOpen ? closeSearch() : openSearch();
			}

			function openSearch() {
				searchBtn.attr('aria-expanded', true);
				search.attr('aria-hidden', false).css('visibility', 'visible');
				updateOverlay();
			}

			function closeSearch() {
				searchBtn.attr('aria-expanded', false);
				search.attr('aria-hidden', true);

				// Ховаємо блок після закінчення анімації
				search.on('transitionend', function() {
					if (search.attr('aria-hidden') === 'true') {
						search.css('visibility', 'hidden');
					}
					search.off('transitionend');
				});

				updateOverlay();
			}

			// Закрити і меню, і пошук разом
			function closeAll() {
				closeMenu();
				closeSearch();
			}

			// Якщо ні меню, ні пошук не відкриті - приховуємо фон і прибираємо клас,
			// інакше показуємо фон і додаємо клас .menu-open до хедера.
			function updateOverlay() {
				const isMenuOpen   = (menuBtn.attr('aria-expanded') === 'true');
				const isSearchOpen = (searchBtn.attr('aria-expanded') === 'true');

				if (isMenuOpen || isSearchOpen) {
					bg.addClass('active');
					ctrl.header.addClass('header-open');
				} else {
					bg.removeClass('active');
					ctrl.header.removeClass('header-open');
				}
			}
		},

		accordionScripts() {
			let btn = $('.accordion-trigger');
			let panel = $('.accordion-panel');

			btn.click(function(){
				const $trigger = $(this);
				const $currentPanel = $trigger.next();
				const isAwardYear = $trigger.hasClass('award-results__question');

				if ($trigger.attr('aria-expanded') === 'true') {
					$trigger.attr('aria-expanded', 'false');
					$currentPanel.attr('aria-hidden', 'true').removeClass('is-open').slideUp(250);
					return;
				}

				if (!isAwardYear) {
					btn.attr('aria-expanded', 'false');
					panel.attr('aria-hidden', 'true').slideUp(250);
				}

				$trigger.attr('aria-expanded', 'true');
				$currentPanel.attr('aria-hidden', 'false').addClass('is-open').slideDown(250);
			});
		},

		partnersSlider() {
			const swiper = new Swiper('.partners-slider', {
				slidesPerView: 'auto',
				loop: true,
				speed: 5000,
				autoplay: {
					delay: 1,
				},
				allowTouchMove: false,
				disableOnInteraction: true,
				spaceBetween: 30,
				breakpoints: {
					576: {
						spaceBetween: 50
					},
					768: {
						spaceBetween: 80
					}
				}
			});
		},

		contentSlider: function() {
			const blockSliders = document.getElementsByClassName('block-content-slider');
			for (let blockSlider of blockSliders) {
				const slider = blockSlider.getElementsByClassName('content-slider')[0];
				const nextEl = blockSlider.getElementsByClassName('block-content-slider-button-next')[0];
				const prevEl = blockSlider.getElementsByClassName('block-content-slider-button-prev')[0];
				const paginate = blockSlider.getElementsByClassName('block-content-slider-pagination')[0];
				let swiper = new Swiper(slider, {
					loop: true,
					pagination: {
						el: paginate,
						type: "fraction",
						formatFractionCurrent: function (number) {
							return number;
						},
						formatFractionTotal: function (number) {
							return number;
						},
						renderFraction: function (currentClass, totalClass) {
							return `<span class="${currentClass}"></span> | <span class="${totalClass}"></span>`;
						}
					},
					navigation: {
						nextEl: nextEl,
						prevEl: prevEl,
					},
					speed: 700,
					effect: "creative",
					creativeEffect: {
						prev: {
							shadow: true,
							translate: ["-20%", 0, -1],
						},
							next: {
							translate: ["100%", 0, 0],
						},
					}
				});
			}
		},

		eventsDropdown() {
			const eventsList = $('#events-list');
			const eventsButton = $('#events-button');

			eventsButton.on('click', function () {
				const isExpanded = $(this).attr('aria-expanded') === 'true';

				eventsList.stop().slideToggle(300);
				$(this).attr('aria-expanded', !isExpanded);
			});

			$(window).on('resize', function () {
				if (window.innerWidth > 1023) {
					eventsList.show().removeAttr('style');
					eventsButton.attr('aria-expanded', 'false');
				}
			}).trigger('resize');
		},

		stickyEvents() {
			let sticky = $('.events-block');
			let stickyWrap = $('.articles-section__events');
			console.log(sticky.height());
			console.log(stickyWrap.innerHeight());
			
			function checkSticky() {
				let stickyTop = parseInt(stickyWrap.offset().top);
				let windowTop = $(window).scrollTop();

				if (windowTop + 100 + sticky.height() > stickyTop + stickyWrap.innerHeight()) {
					sticky.addClass('bottom');
					sticky.removeClass('fixed');
					sticky.css('width', '');
				} else if (stickyTop <= windowTop + 100) {
					sticky.addClass('fixed');
					sticky.css('width', stickyWrap.width() + 'px');
					sticky.removeClass('bottom');
				} else {
					sticky.removeClass('fixed');
					sticky.css('width', '');
					sticky.removeClass('bottom');
				}
			}

			function toggleSticky() {
				let stickyHeight = sticky.outerHeight(true);
				let stickyWrapHeight = stickyWrap.innerHeight();

				if ($(window).width() >= 1024 && stickyHeight < stickyWrapHeight) {
					$(window).on('scroll', checkSticky); // Вмикаємо перевірку на скрол
					checkSticky(); // Одразу перевіряємо при завантаженні або ресайзі
				} else {
					$(window).off('scroll', checkSticky); // Прибираємо перевірку на скрол
					sticky.removeClass('fixed bottom');
					sticky.css('width', '');
				}
			}

			// Перевірка ширини екрана під час завантаження сторінки
			toggleSticky();

			// Перевірка ширини екрана при зміні розміру вікна
			$(window).on('resize', toggleSticky);
		},
		
		clipboard() {
			let copyBlock = $('.copy-btn');

			copyBlock.each(function() {
				$(this).click(function(){
					let text = $(this).data('copy-text');
					navigator.clipboard.writeText(text);

					if ($('.clipboard-popup').length) {
						$('.clipboard-popup').remove()
					}

					let popup = $('<div/>').appendTo('#page');
					popup.attr('class', 'clipboard-popup').attr('aria-live', 'polite').text($(this).data('popup-text'));

					popup.addClass('active');

					setTimeout(function () {
						popup.removeClass('active').removeAttr('style');
						popup.remove();
					}, 2000);
				});
			});
		},

		searchReset() {
			let searchInput = $('.search-input');
			searchInput.each(function() {
				let thisInput = $(this);
				let searchReset = thisInput.siblings('.search-form__reset');
				if (thisInput.length) {
					if (thisInput.val() != '') {
						searchReset.addClass('show');
					}
					thisInput.keyup( function() {
						if (thisInput.val() != '') {
							searchReset.addClass('show');
						} else {
							searchReset.removeClass('show');
						}
					});
				}
				searchReset.click(function(){
					thisInput.val('');
					thisInput.focus();
					searchReset.removeClass('show');
				});
			});
		},

		filters() {
			const filtersContainer = $('.filters');
			const filters = filtersContainer.find('.filter');
			const allResetButton = filtersContainer.find('.filters__reset');
			const checkboxes = filtersContainer.find('input[type="checkbox"]');

			// Відкриття/закриття дропдаунів
			filters.find('.filter__title').on('click', function () {
				const currentFilter = $(this).closest('.filter');
				const dropdown = currentFilter.find('.filter__dropdown');

				// Закриваємо всі інші дропдауни
				filters.not(currentFilter).find('.filter__dropdown').removeClass('filter-open');
				filters.not(currentFilter).find('.filter__title').attr('aria-expanded', false);
				$(document).off('click.filterDropdown');

				// Перемикаємо поточний дропдаун
				const isExpanded = $(this).attr('aria-expanded') === 'true';
				if (isExpanded) {
					dropdown.removeClass('filter-open');
					$(this).attr('aria-expanded', false);
				} else {
					dropdown.addClass('filter-open');
					$(this).attr('aria-expanded', true);

					// Додаємо обробник для кліків поза фільтром
					$(document).on('click.filterDropdown', function (e) {
						if (!$(e.target).closest('.filter').length) {
							filters.find('.filter__dropdown').removeClass('filter-open');
							filters.find('.filter__title').attr('aria-expanded', false);
							$(document).off('click.filterDropdown'); // Отключаем обработчик
						}
					});
				}
			});

			// Оновлення постів у разі зміни фільтрів
			checkboxes.on('change', function () {
				const currentFilter = $(this).closest('.filter');
				toggleActiveClass(currentFilter);
				toggleAllResetButton();
				updatePosts();
			});

			// Скидання окремого фільтра
			filters.find('.filter__reset button').on('click', function (e) {
				e.preventDefault();
				const currentFilter = $(this).closest('.filter');
				resetFilters(currentFilter); // Скидаємо поточний фільтр
				toggleAllResetButton();
				updatePosts();
			});

			// Скидання всіх фільтрів
			allResetButton.on('click', function (e) {
				e.preventDefault();
				resetFilters(); // Скидаємо всі фільтри
				toggleAllResetButton();
				updatePosts();
			});

			// Функція скидання фільтрів
			function resetFilters(filter = null) {
				if (filter) {
					filter.find('input[type="checkbox"]').prop('checked', false);
					toggleActiveClass(filter);
				} else {
					checkboxes.prop('checked', false);
					filters.removeClass('active');
					allResetButton.hide();
				}
			}

			// Функція оновлення класу active
			function toggleActiveClass(filter) {
				const hasActiveCheckbox = filter.find('input[type="checkbox"]:checked').length > 0;
				filter.toggleClass('active', hasActiveCheckbox);
			}

			// Функція показу/приховування кнопки скидання всіх фільтрів
			function toggleAllResetButton() {
				const hasActiveFilters = checkboxes.filter(':checked').length > 0;
				if (hasActiveFilters) {
					allResetButton.show();
				} else {
					allResetButton.hide();
				}
			}

			// Функція оновлення постів
			function updatePosts() {
				let l = '';
				if (lang != 'uk') {
					l = '/' + lang;
				}
				const filters = {};
				const postType = filtersContainer.data('post-type');
				const taxonomies = filtersContainer.data('taxonomies').split(',');

				// Збираємо вибрані значення фільтрів
				taxonomies.forEach(function (taxonomy) {
					filters[taxonomy] = [];
					filtersContainer
						.find(`.filter[data-taxonomy="${taxonomy}"] input[type="checkbox"]:checked`)
						.each(function () {
							filters[taxonomy].push($(this).val());
						});
				});

				// Генеруємо рядок параметрів
				const filterArgs = getFilterArgs(filters);

				// Оновлюємо URL
				history.pushState('','', window.location.origin + l + '/' + postType + '/' + filterArgs);

				$.ajax({
					url: ajaxurl,
					method: 'POST',
					dataType: 'json',
					data: {
						action: 'filter_posts',
						postType: postType,
						filters: filters,
						filterArgs: filterArgs
					},
					success: function (response) {
						$('.archive-posts__list').html(response.posts);
						$('.pagination').html(response.pagination);
					},
				});
			}

			// Функція генерації рядка параметрів
			function getFilterArgs(filters) {
				const urlParams = [];
				for (const taxonomy in filters) {
					if (filters[taxonomy].length > 0) {
						urlParams.push(`${taxonomy}=${filters[taxonomy].join(',')}`);
					}
				}
				return urlParams.length > 0 ? `?${urlParams.join('&')}` : '';
			}

		},

		subscription() {
			var form = $('#custom-mailchimp-form');
			var emailInput = form.find('input[name="EMAIL"]');
			var fieldError = form.find('.subscription-form__field-error'); 
			var successBlock = $('.subscription-success');

			emailInput.on('invalid', function() {
				emailInput.addClass('error');
			});

			// Обробник зміни введення для приховування кастомних помилок
			emailInput.on('input', function() {
				// Приховуємо кастомне повідомлення про помилку при будь-якій зміні введення
				if (fieldError.is(':visible')) {
					fieldError.hide().text('');
				}
				// Також приховуємо повідомлення про успіх, якщо користувач починає вводити новий email
				if (successBlock.is(':visible')) {
					successBlock.hide();
				}
				// Видаляємо клас 'error' якщо користувач починає вводити новий email
				emailInput.removeClass('error');
			});

			form.on('submit', function(e) {
				e.preventDefault();

				// Спочатку приховуємо повідомлення про помилки, успіхи
				fieldError.hide().text('');
				successBlock.hide();
				
				emailInput.removeClass('error');

				var emailVal = emailInput.val().trim();

				// 1. Перевіряємо, чи не порожнє поле
				if (!emailVal) {
					fieldError.text(themeTexts.subscriptionForm.fieldEmpty).show();
					emailInput.addClass('error');
					return;
				}
				// 2. Перевіряємо валідність email через регулярку
				var emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
				if (!emailPattern.test(emailVal)) {
					fieldError.text(themeTexts.subscriptionForm.invalidEmail).show();
					emailInput.addClass('error');
					return;
				}

				// Якщо дійшли сюди - email коректний, відправляємо на Mailchimp
				var mailchimpUrl = 'https://sss-ua.us16.list-manage.com/subscribe/post-json'
					+ '?u=1019d82f945439d157b4d063c'
					+ '&id=6b052c4114'
					+ '&c=?';

				$.ajax({
					url: mailchimpUrl,
					method: 'GET',
					dataType: 'jsonp',
					data: {
						EMAIL: emailVal
					},
					success: function(response) {
						console.log(response);
						if (response.result === 'success') {
							// Перевіряємо, чи містить повідомлення інформацію про вже підписаний email
							// У нашому випадку повідомлення: «You're already subscribed, your profile has been updated. Дякуємо!»
							if (response.msg && response.msg.toLowerCase().includes('already subscribed')) {
								// Показуємо кастомне повідомлення для вже підписаного email
								fieldError.text(themeTexts.subscriptionForm.alreadySubscribed).show();
								emailInput.addClass('error');
							} else {
								// Показуємо повідомлення про успішну підписку
								form.addClass('hide');
								successBlock.show();
							}
							// Опціонально: очищаємо форму
							form[0].reset();
						} else if (response.result === 'error') {
							// Обробляємо помилку від Mailchimp
							// Видаляємо HTML-теги з повідомлення
							var errorMessage = response.msg || themeTexts.subscriptionForm.errorTryAgain;
							errorMessage = errorMessage.replace(/<[^>]*>?/gm, '');
							fieldError.text(errorMessage).show();
							emailInput.addClass('error');
						}
					},
					error: function() {
						// Спрацьовує, якщо запит не вдався (наприклад, проблеми з мережею)
						fieldError.text(themeTexts.subscriptionForm.serverError).show();
						emailInput.addClass('error');
					}
				});
			});
		},

		feedbackForm() {
			// Валідація тільки тексту
			const nameField = $('input[name="feedback-name"]');

			nameField.on('input', function() {
				// Видаляємо все, крім букв, пробілів і дефісів
				const cleanValue = $(this).val().replace(/[^A-Za-zА-Яа-яЁёІіЇїЄєҐґ\s\-]/g, '');
				$(this).val(cleanValue);
			});

			$(".wpcf7-form").on("input", ".wpcf7-not-valid", function() {
				$(this).removeClass( "wpcf7-not-valid" );
			});

			$('.feedback-form').on('wpcf7mailsent', function (event) {
				let formWrap = $('.feedback-section__form');
				let formSuccess = $('.feedback-section__success');

				formWrap.addClass('hide');
				formSuccess.show();
			});
		},

		init() {
			this.varInit();
			this.headerScripts();
			if ($('.accordion-trigger').length) {
				this.accordionScripts();
			}
			if ($('.partners-slider').length) {
				this.partnersSlider();
			}
			if ($('.content-slider').length) {
				this.contentSlider();
			}
			if ($('.events-block').length) {
				this.eventsDropdown();
				this.stickyEvents();
			}
			this.clipboard();
			this.searchReset();
			if ($('.filters').length) {
				this.filters();
			}
			this.subscription();
			this.feedbackForm();
		},
	};

	$(document).ready(function () {
		Scripts.init();
	});
});